/**
 * Download a cross-origin file by fetching it as a blob and triggering
 * a programmatic click on a temporary blob URL.
 * The `download` attribute on <a> is ignored by browsers for cross-origin URLs,
 * so this is the only reliable way to force a Save dialog with a custom filename.
 */
export async function downloadFile(url: string, filename: string): Promise<void> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Small delay before revoking so the browser has time to start the download
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
}
